import script from "./SitemapHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SitemapHeader.vue?vue&type=script&setup=true&lang=js"

import "./SitemapHeader.vue?vue&type=style&index=0&id=e131975e&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e131975e"]])

export default __exports__